'use client';

import { useEffect, useState } from 'react';

export const useLocalStorage = <T>(
  key: string,
  defaultValue: T
): [T, (value: ((prevState: T) => T) | T) => void] => {
  const [value, setValue] = useState( defaultValue );

  useEffect( () => {
    const storedValue = window.localStorage.getItem( key );

    if (storedValue !== null) {
      setValue( JSON.parse( storedValue ) );
    }
  }, [key] );

  useEffect( () => {
    window.localStorage.setItem( key, JSON.stringify( value ) );
  }, [key, value] );

  return [value, setValue];
};
